<template>
  <div id="camera"></div>
</template>

<script>
import Quagga from 'quagga';

export default {
  name: 'BarcodeReader',
  methods: {
    initializeCamera() {
      Quagga.init({
        locate: true,
        inputStream : {
          name : "Live",
          type : "LiveStream",
          target: document.getElementById('camera')
        },
        constraints: {
          width: 200
        },
        frequency: .5,
        decoder : {
          readers : ["code_128_reader", "ean_reader"]
        },
        locator: {
          halfSample: true,
          patchSize: "medium", // x-small, small, medium, large, x-large
          debug: {
            showCanvas: false,
            showPatches: false,
            showFoundPatches: false,
            showSkeleton: false,
            showLabels: false,
            showPatchLabels: false,
            showRemainingPatchLabels: false,
            boxFromPatches: {
              showTransformed: false,
              showTransformedBox: false,
              showBB: false
            }
          }
        }
      }, function(err) {
        if (err) {
          console.log(err);
          return
        }
        console.log("Initialization finished. Ready to start");
        Quagga.start();
      });

      Quagga.onDetected(data => this.$emit('barcodeRead', data.codeResult.code));
    },
    stopCamera() {
      console.log("Camera stopped.");
      Quagga.stop();
    }
  },
  mounted() {
    this.initializeCamera();
  },
  destroyed() {
    this.stopCamera();
  }
}
</script>

<style>
#camera {
  width: 100%;
  height: 150px;
  overflow: hidden;
  position: relative;
}

#camera > video, 
#camera > canvas {
  max-width: 100%;
  width: 100%;
}

#camera > canvas {
  display: none;
}
</style>